import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Navigation, Plane, Mountain } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
const MAP_EMBED_URL = 'https://www.google.com/maps?q=Los+Notros+861,+R8402+Dina+Huapi,+R%C3%ADo+Negro&z=15&output=embed';
const DIRECTIONS_URL = 'https://www.google.com/maps?um=1&ie=UTF-8&fb=1&gl=ar&sa=X&geocode=KVuSghREhxqWMa-mi8rXDWVc&daddr=Los+Notros+861,+R8402+Dina+Huapi,+R%C3%ADo+Negro';
export function Location() {
  const {
    t
  } = useLanguage();
  const distances = [{
    icon: Mountain,
    label: t('San Carlos de Bariloche', 'San Carlos de Bariloche'),
    value: t('15 km · 20 min en auto', '15 km · 20 min by car')
  }, {
    icon: Plane,
    label: t('Aeropuerto de Bariloche', 'Bariloche Airport'),
    value: t('10 km · 12 min en auto', '10 km · 12 min by car')
  }, {
    icon: Navigation,
    label: t('Lago Nahuel Huapi', 'Lake Nahuel Huapi'),
    value: t('A pocas cuadras', 'A few blocks away')
  }];
  return <section id="ubicacion" className="py-24 bg-background" data-id="element-231" data-mp="z7nu521weer6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-232" data-mp="ub776b6fq6fo">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start" data-id="element-233" data-mp="197odgnzrouvd">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.4,
          ease: [0.23, 1, 0.32, 1]
        }} className="lg:col-span-4" data-id="element-234" data-mp="195by8ile8ym0">
            <span className="text-accent font-medium tracking-wider uppercase text-sm mb-3 block" data-id="element-235" data-mp="bhthakhkwq6x">
              {t('Ubicación', 'Location')}
            </span>
            <h2 className="text-3xl md:text-4xl font-serif text-primary mb-6" data-id="element-236" data-mp="lh2hvw6y9329">
              {t('Cómo llegar a las cabañas', 'How to get to the cabins')}
            </h2>

            <p className="flex gap-3 text-gray-700 mb-8" data-id="element-237" data-mp="3oz2lz09dwoal">
              <MapPin className="w-5 h-5 text-accent shrink-0 mt-0.5" data-id="element-238" data-mp="3oykgre4quzqj" />
              <span data-id="element-239" data-mp="igsl4exccf8e">
                Los Notros 861, R8402
                <br data-id="element-240" data-mp="mixc15wemxrc" />
                Dina Huapi, Río Negro
                <br data-id="element-241" data-mp="mhcj1kpqnmvl" />
                {t('Patagonia Argentina', 'Argentine Patagonia')}
              </span>
            </p>

            <dl className="space-y-5 mb-8 pt-6 border-t border-surface" data-id="element-242" data-mp="rc8derig6mbv">
              {distances.map(item => {
              const Icon = item.icon;
              return <div key={item.label} className="flex gap-3" data-id="element-243" data-mp="3vq6s80qxriem">
                    <Icon className="w-5 h-5 text-accent shrink-0 mt-0.5" data-id="element-244" data-mp="3lcpw6l0ydaf" />
                    <div data-id="element-245" data-mp="8iux9sje8kgb">
                      <dt className="text-sm font-medium text-gray-900" data-id="element-246" data-mp="8iml62v3hj66">
                        {item.label}
                      </dt>
                      <dd className="text-sm text-gray-600" data-id="element-247" data-mp="dg4kd1jb8k0z">{item.value}</dd>
                    </div>
                  </div>;
            })}
            </dl>

            <a href={DIRECTIONS_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary text-white font-medium whitespace-nowrap hover:bg-primary-light transition-colors" data-id="element-248" data-mp="1ow2znn5302an">
              <Navigation className="w-4 h-4" data-id="element-249" data-mp="2zo2fnvepvn6i" />
              {t('Cómo llegar en Google Maps', 'Get directions on Google Maps')}
            </a>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.4,
          delay: 0.08,
          ease: [0.23, 1, 0.32, 1]
        }} className="lg:col-span-8" data-id="element-250" data-mp="2qq8heexe6jgp">
            <div className="rounded-2xl overflow-hidden border border-surface shadow-sm" data-id="element-251" data-mp="2bsznbdgpf1la">
              <iframe src={MAP_EMBED_URL} title={t('Mapa con la ubicación de Cabañas Clarita en Dina Huapi', 'Map showing the location of Cabañas Clarita in Dina Huapi')} className="w-full h-[380px] md:h-[480px] border-0" loading="lazy" referrerPolicy="no-referrer-when-downgrade" allowFullScreen data-id="element-252" data-mp="ezwdkz0gnuau" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}